import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import JTextField from './JTextField';
import JSelect from './JSelect';
import { data } from '../utils';

const { playhouse: { registration: { idCardOptions } } } = data;

const AuthorizedInformation = ({
  id,
  dispatch,
  number,
  fullName,
  contactNumber,
  idCardType,
  idNumber,
  errors,
}) => {
  const [formErrors, setErrors] = useState([]);

  const handleChange = (type, value) => {
    const field = Object.keys(value)[0];
    let updatedErrors = [];

    if (!value[field] || value[field] === '') {
      if (errors) {
        updatedErrors = errors.includes(field) ? errors : [...errors, field];
      } else {
        updatedErrors = [field];
      }
    } else {
      updatedErrors = errors && errors.filter((err) => err !== field);
    }
    dispatch({ type, payload: { id, ...value, errors: updatedErrors } });
  };

  useEffect(() => {
    if (Array.isArray(errors)) {
      setErrors(errors);
    }
  }, [errors]);

  return (
    <div>
      <h2 className="text-gray-400 mb-4">
        Authorized Person #
        {number}
      </h2>
      <div className="md:flex text-left md:gap-x-8">
        <JTextField
          label="Full name"
          value={fullName}
          onChange={
            (e) => handleChange('updateAuthorizedPerson', { fullName: e.target.value })
          }
          hasError={formErrors.includes('fullName')}
          errorMessage="Full name is required"
          required
        />
        <JTextField
          label="Contact number"
          value={contactNumber}
          required
          hasError={formErrors.includes('contactNumber')}
          errorMessage="Contact number is required"
          onChange={
            (e) => handleChange('updateAuthorizedPerson', { contactNumber: e.target.value })
          }
        />
      </div>

      <div className="md:flex text-left md:gap-x-8">
        <JSelect
          label="ID Card Type"
          value={idCardType}
          options={idCardOptions}
          onChange={
            (e) => handleChange('updateAuthorizedPerson', { idCardType: e.target.value })
          }
          hasError={formErrors.includes('idCardType')}
          errorMessage="ID card type is required"
          required
        />
        <JTextField
          label="ID Number"
          value={idNumber}
          onChange={
            (e) => handleChange('updateAuthorizedPerson', { idNumber: e.target.value })
          }
          hasError={formErrors.includes('idNumber')}
          errorMessage="ID number is required"
          required
        />
      </div>
    </div>
  );
};

AuthorizedInformation.propTypes = {
  dispatch: PropTypes.func.isRequired,
  id: PropTypes.number.isRequired,
  number: PropTypes.string.isRequired,
  fullName: PropTypes.string.isRequired,
  contactNumber: PropTypes.string.isRequired,
  idCardType: PropTypes.string.isRequired,
  idNumber: PropTypes.string.isRequired,
  errors: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default AuthorizedInformation;
